import React from "react";
import "../../styles/match-filters.css";

/**
 * Match filters component for filtering matches by status and team
 * @param {Object} props - Component props
 * @param {Object} props.filters - Current filter values
 * @param {Function} props.setFilters - Function to update filters
 * @returns {JSX.Element} - Match filters component
 */
export const MatchFilters = ({ filters, setFilters }) => {
  const handleStatusChange = (e) => {
    setFilters({...filters, status: e.target.value || undefined, page: 1});
  };
  
  const handleTeamChange = (e) => {
    setFilters({...filters, teamId: e.target.value || undefined, page: 1});
  };
  
  const handleSortChange = (e) => {
    setFilters({...filters, sort: e.target.value || undefined});
  };
  
  const handleClearFilters = () => {
    setFilters({
      page: 1,
      limit: filters.limit || 10
    });
  };
  
  return (
    <div className="match-filters-container">
      <div className="filter-item">
        <label>Status</label>
        <select value={filters.status || ""} onChange={handleStatusChange}>
          <option value="">All Statuses</option>
          <option value="scheduled">Scheduled</option>
          <option value="in_progress">In Progress</option>
          <option value="completed">Completed</option>
          <option value="cancelled">Cancelled</option>
        </select>
      </div>
      
      <div className="filter-item">
        <label>Sort By</label>
        <select value={filters.sort || "-date"} onChange={handleSortChange}>
          <option value="-date">Newest First</option>
          <option value="date">Oldest First</option>
        </select>
      </div>
      
      <button className="clear-filters-btn" onClick={handleClearFilters}>
        Clear Filters
      </button>
    </div>
  );
};
